export default __webpack_public_path__ + "static/media/mugalgarden.9d931600.jpg";